import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field } from "@/components/common";
import { api, errMsg, num } from "@/lib/api";

export default function RatesDialog({ open, onOpenChange, rates, onSaved }) {
  const [f, setF] = useState({ USD: "", EUR: "" });
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setF({ USD: rates?.USD ?? "", EUR: rates?.EUR ?? "" }); }, [open, rates]);
  const submit = async (body, msg) => {
    setBusy(true);
    try {
      await api.put("/rates", body);
      toast.success(msg);
      onOpenChange(false);
      onSaved?.();
    } catch (e) {
      toast.error(errMsg(e));
    }
    setBusy(false);
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm rounded-[4px]" data-testid="rates-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Döviz Kuru</DialogTitle>
          <DialogDescription>Kurları elle girin ya da otomatik piyasa kuruna dönün.{rates?.auto?.USD && ` Otomatik: $ ${num(rates.auto.USD)} · € ${num(rates.auto.EUR)}`}</DialogDescription>
        </DialogHeader>
        <form onSubmit={(e) => { e.preventDefault(); submit({ USD: Number(f.USD) || null, EUR: Number(f.EUR) || null }, "Kurlar güncellendi"); }} className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <Field label="1 USD = ₺"><Input type="number" step="0.0001" min="0.0001" value={f.USD} onChange={(e) => setF({ ...f, USD: e.target.value })} data-testid="rates-usd-input" /></Field>
            <Field label="1 EUR = ₺"><Input type="number" step="0.0001" min="0.0001" value={f.EUR} onChange={(e) => setF({ ...f, EUR: e.target.value })} data-testid="rates-eur-input" /></Field>
          </div>
          <DialogFooter className="gap-2 sm:justify-between">
            <Button type="button" variant="ghost" className="rounded-[4px]" disabled={busy || rates?.source !== "manual"} onClick={() => submit({}, "Otomatik kura dönüldü")} data-testid="rates-auto-button">Otomatik Kura Dön</Button>
            <Button type="submit" className="rounded-[4px]" disabled={busy} data-testid="rates-save-button">Kaydet</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
